import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {MetadataStructure, MetadataStructureListResult} from '../../model/filter/stateListResult.model';
import {FilterService} from '../../services/filter/filter.service';
import {FormBuilder, FormGroup, FormControl} from '@angular/forms';
import {ConfigurationService} from '../../services/configuration/configuration.service';
import {GroupingConfiguration} from '../../model/configuration/groupingConfiguration.model';
import {ToastrService} from 'ngx-toastr';
import {GroupingConfigurationResult} from '../../model/configuration/groupingConfigurationResult';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {GenericModalService} from '../../services/utils/generic-modal.service';



@Component({
  selector: 'app-config-interaction-queue',
  templateUrl: './config.interactionQueue.component.html',
  styleUrls: ['./config.interactionQueue.component.css']
})

export class ConfigInteractionQueueComponent implements OnInit {
  metadataStructureList: Array<any> = [];
  queueConfigListForOrder: any[];
  queueConfigList: any[];
  selectedConfig: any;
  domainValue: string;
  isValidDisplayName: boolean;
  isValidMetadataName: boolean;
  isSaving: boolean;
  successfullySaved: boolean;
  isConfigLoading: boolean;
  public modalOrderRef: BsModalRef;

  public selected: any[] = [];

  constructor(private modalService: BsModalService, private filterService: FilterService,
              private configurationService: ConfigurationService, private fb: FormBuilder,
              private toastr: ToastrService,
              public bsModalRef: BsModalRef,
              public genericModalService: GenericModalService) {
    this.isConfigLoading = false;
    this.listInteractionQueueConfigurations();
    this.selectedConfig = {};
  }

  metadataStructureCtrl = new FormControl();
  formMetadataStructure = new FormGroup({
    metadataList: this.metadataStructureCtrl
  });

  listInteractionQueueConfigurations(): void {
    this.isConfigLoading = true;
    this.queueConfigList = [];

    this.configurationService.listInteractionQueueConfigurations().subscribe((resp: any) => {
      if (resp.result) {
        this.queueConfigList = resp.result;
      } else if (resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
      }
      this.isConfigLoading = false;
    });
  }


  ngOnInit() {
    this.modalService.onShow.subscribe((reason: string) => {
      this.getMetadataStructures();
    });
  }

  getMetadataStructures(): void {
      this.filterService.getMetadataStructures().subscribe((resp: MetadataStructureListResult) => {
        if (resp.result) {
          this.metadataStructureList = resp.result;
        } else if (resp.error) {
          this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
        }
      });
  }

  onClickNew(staticModel: TemplateRef<any>) {
    this.configEditingModal();
    this.isValidDisplayName = this.isValidMetadataName = false;

    this.selectedConfig = {};
    // this.modalRef = staticModel;
    // staticModel.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}); // , 'modal-xl');
  }

  onClickOrder(orderModal: TemplateRef<any>) {
    this.queueConfigListForOrder = [];
    for (const item of this.queueConfigList) {
      this.queueConfigListForOrder.push(Object.assign({}, item));
    }
    // this.modalOrderRef = orderModal;
    // orderModal.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(orderModal, {}, 'modal-xs');
  }

  onClickEdit(content, staticModel) {
    this.selectedConfig = Object.assign({}, content);
    this.configEditingModal();
    // this.modalRef = staticModel;
    // staticModel.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}); // , 'modal-xl');
  }

  onClickDelete(content: GroupingConfiguration) {
    this.selectedConfig = Object.assign({}, content);
  }

  onClickConfirmDelete() {
    this.configurationService.deleteInteractionQueueConfiguration(this.selectedConfig.id).subscribe((resp: any) => {
      this.toastr.success('Configuração ' + this.selectedConfig.metadataStructureName +
        ' excluída com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
      this.listInteractionQueueConfigurations();
    });
  }

  configEditingModal() {
    this.getMetadataStructures();
    this.isValidDisplayName = true;
    this.isValidMetadataName = true;
    this.successfullySaved = false;
    this.domainValue = undefined;
    this.isSaving = false;
  }


  onChangeDisplayName() {
    this.validateDisplayName();
  }

  typeaheadNoResults(noResults: boolean) {
    this.isValidMetadataName = !noResults;
  }

  onClickSaveConfig() {

    if (!this.isValidForm()) {
      this.toastr.error('Não é possível salvar pois existe(m) campo(s) inválido(s).', 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    if (this.queueConfigList && this.queueConfigList.length > 0) {
      const lastOrder = this.queueConfigList.reduce(function (prev, curr) {
        return prev.order > curr.order ? prev : curr;
      });
      this.selectedConfig.order = lastOrder.order + 1;
     } else {
       this.selectedConfig.order = 1;
     }

    this.isSaving = true;
    this.configurationService.saveInteractionQueueConfiguration(this.selectedConfig)
      .subscribe(
      (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Configuração salva com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
            this.isSaving = false;
            this.onCloseModal();
            this.listInteractionQueueConfigurations();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
          }
          this.isSaving = false;
        }
      );
  }

  isValidForm() {
    this.validateDisplayName();
    this.validateMetadataName();

    return this.isValidDisplayName && this.isValidMetadataName;
  }

  validateDisplayName() {
    return this.isValidDisplayName = this.selectedConfig.displayName != undefined &&
      this.selectedConfig.displayName.trim() != '';
  }


  validateMetadataName() {
    return this.isValidMetadataName = this.selectedConfig.metadataStructureName != undefined &&
      this.selectedConfig.metadataStructureName.trim() != '';;
  }

  onSelectMetadata(event: TypeaheadMatch) {
    this.selectedConfig.metadataStructureName = event.item.name;
  }

  onCleanMetadataStructure() {
    this.selectedConfig.metadataStructureName = undefined;
    this.isValidMetadataName = false;
  }

  onClickSaveOrder() {
    let count = 0;
    for (const item of this.queueConfigListForOrder) {
      count++;
      item.order = count;
    }

    this.isSaving = true;
    this.configurationService.saveInteractionQueueConfigurationList(this.queueConfigListForOrder)
      .subscribe(
        (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Configurações salvas com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
            this.isSaving = false;
            this.onCloseModal();
            this.listInteractionQueueConfigurations();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
          }
          this.isSaving = false;
        }
      );

  }

  onCloseModal() {
    this.bsModalRef.hide();
  }


}
